import { ObservableArray, View } from "binder"
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";
import { ServerSideDataLoader } from "uicomponents";
import { workAs, WorkAsManipulationViewModel } from "./workAsManipulation-viewModel";

export class WorkAsManipulationView extends View<WorkAsManipulationViewModel>{
    GetViewUniqueId(): string {
        return "V-83CEAB5B-73BB-48E3-A41A-41114C1DADCC"
    }
    loadHtml(): string {
        let element = require('./workAsManipulation.html').default;
        let style = require('./workAsManipulation.less');
        return element;
    }
    constructor() {
       super();
    }

    public set loader(v: ServerSideDataLoader) { this._loader = v; } public get loader(): ServerSideDataLoader { return this._loader;} private _loader: ServerSideDataLoader;
    public set workAs(v: ObservableArray<workAs>) { this._workAs = v; } public get workAs(): ObservableArray<workAs> { return this._workAs;} private _workAs: ObservableArray<workAs>;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set isShowingPopup(v: boolean) { this._isShowingPopup = v; } public get isShowingPopup(): boolean { return this._isShowingPopup;} private _isShowingPopup: boolean;
    public set popup(v: IPopup) { this._popup = v; } public get popup(): IPopup { return this._popup;} private _popup: IPopup;
     
    requestWorkAsCreation(){
        this.dataContext.requestWorkAsCreation();
    }
}
